<div class="finder-layout" [ngClass]="{'loading': !loaded}">
    <!-- Header -->
    @if (layoutService.header) {
        <header class="finder-header">
            <ng-content select=".header"></ng-content>
        </header>
    }
    <!-- Loading Spinner -->
    @if (!loaded) {
        <finder-loading-spinner></finder-loading-spinner>
    }
    <!-- Actual Content -->
    <main class="finder-content">
        @if (error) {
            <finder-system-error [status]="error.status" [bundle]="languageBundle"></finder-system-error>
        }

        @if (error?.error?.myIdGated) {
            <p class="gated-myid-error"> {{ error.error.myIdGatedMessage }} </p>
        }

        <ng-content select=".content"></ng-content>
    </main>
    <!-- Footer -->

    @if (layoutService.footer) {
        <footer class="finder-footer">
            <ng-content select=".footer"></ng-content>
        </footer>
    }
</div>
